/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { PagedResultDto_EsppParticipantDataDto } from '../models/PagedResultDto_EsppParticipantDataDto';
import type { Wealthlane_AwardService_Dtos_EsppDtos_EsppParticipantsDtos_EsppParticipantSendInvitationEmailRequest } from '../models/Wealthlane_AwardService_Dtos_EsppDtos_EsppParticipantsDtos_EsppParticipantSendInvitationEmailRequest';
import type { Wealthlane_Shared_Hosting_Dtos_GenericApiResponse } from '../models/Wealthlane_Shared_Hosting_Dtos_GenericApiResponse';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class EsppParticipantService {

    /**
     * @param employeeId 
     * @param email 
     * @param invitationEmailSent 
     * @param filter 
     * @param sorting 
     * @param skipCount 
     * @param maxResultCount 
     * @returns PagedResultDto_EsppParticipantDataDto OK
     * @throws ApiError
     */
    public static getApiAwardApiEsppParticipants(
employeeId?: string,
email?: string,
invitationEmailSent?: boolean,
filter?: string,
sorting?: string,
skipCount?: number,
maxResultCount?: number,
): CancelablePromise<PagedResultDto_EsppParticipantDataDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/award/api/espp-participants',
            query: {
                'EmployeeId': employeeId,
                'Email': email,
                'InvitationEmailSent': invitationEmailSent,
                'Filter': filter,
                'Sorting': sorting,
                'SkipCount': skipCount,
                'MaxResultCount': maxResultCount,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @param requestBody 
     * @returns Wealthlane_Shared_Hosting_Dtos_GenericApiResponse OK
     * @throws ApiError
     */
    public static postApiAwardApiEsppParticipantsSendInvitationEmail(
requestBody?: Wealthlane_AwardService_Dtos_EsppDtos_EsppParticipantsDtos_EsppParticipantSendInvitationEmailRequest,
): CancelablePromise<Wealthlane_Shared_Hosting_Dtos_GenericApiResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/award/api/espp-participants/send-invitation-email',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

}
